import { getStoreToken } from '@/utils'

export default {
  namespaced: true,
  state: {
    token: getStoreToken()
  }
}
